import type { Theme } from "../contexts/ThemeProvider";
import shared from "../data/js/shared";

const { toggleDarkModeLabel, darkModeOnLabel } = shared.account;

export interface DarkModeLabelProps {
  theme: Theme;
  /** ThemeProvider's `hydrated` flag. */
  hydrated: boolean;
}

/**
 * Caption for the dark-mode toggle, shown on the account page and in the login
 * panel.
 *
 * ThemeProvider seeds `theme` from the pre-hydration script, so on the first
 * client render it is the visitor's stored theme while the server rendered the
 * default one. Reading `theme` straight into this text node made those two
 * disagree and React threw a hydration mismatch (#418) at every visitor whose
 * stored theme was not the default. Until the provider reports `hydrated` we
 * render the same label the server did; the provider's mount effect then
 * re-renders with the real theme.
 */
export const DarkModeLabel = ({ theme, hydrated }: DarkModeLabelProps) =>
  hydrated && theme === "light" ? toggleDarkModeLabel : darkModeOnLabel;

export default DarkModeLabel;
